<template>
  <Dropdown
    :style="{width: '100%', position: 'relative'}"
    :visible="visible"
    class="customDrop"
    ref="dropRef"
    trigger="custom"
  >
    <Input
      :icon="visible?'ios-arrow-up':'ios-arrow-down'"
      :placeholder="placeholder"
      @on-clear="clear"
      @on-click="handleOpen"
      @on-focus="handleOpen"
      autocomplete="off"
      readonly
      v-model="categoryNames"
    ></Input>
    <DropdownMenu slot="list">
      <div class="treePanel">
        <div class="treeContainer">
          <Tree
            :check-strictly="true"
            :data="categoryTree"
            :multiple="multiple"
            :render="renderContent"
            @on-select-change="changeSelectNode"
            class="categoryTree"
          ></Tree>
        </div>
      </div>
    </DropdownMenu>
  </Dropdown>
</template>
<script>
export default {
  name: 'knowledgeCategory',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    placeholder: {
      required: false,
      default: '请选择知识类目'
    },
    multiple: {
      required: false,
      type: Boolean,
      default: true
    },
  },
  watch: {
    value: {
      handler (val) {
        this.chks = val
        this.dealTreeData()
      },
      immediate: true
    }
  },
  data () {
    return {
      visible: false,
      categoryIds: [],
      categoryNames: '',
      categoryTree: [],
      current: null,
      chks: []
    }
  },
  methods: {
    changeSelectNode: function (checked, current) {
      this.current = current
      this.categoryIds = []
      const categoryList = []
      for (const idx in checked) {
        this.categoryIds.push(checked[idx].id)
        categoryList.push(checked[idx].name)
      }
      this.$emit('change', this.categoryIds)
      this.categoryNames = categoryList.join('，')
      this.$emit('changeSelectNode', { checked: checked.length > 0, node: current })
    },
    close: function () {
      this.visible = false
    },
    handleOpen: function () {
      this.visible = !this.visible
    },
    clear: function () {
      this.close()
    },
    outClick (e) {
      let dropRef = this.$refs.dropRef.$el
      if (!dropRef.contains(e.target) && this.visible) {
        this.visible = false
      }
    },
    traverseTree: function (nodes, chkNames) {
      if (nodes === null || nodes === undefined || nodes.length === 0) return
      for (let i = 0; i < nodes.length; i++) {
        if (this.chks.includes(nodes[i].id)) {
          this.$set(nodes[i], 'selected', true)
          chkNames.push(nodes[i].name)
        }
        this.traverseTree(nodes[i].children, chkNames)
      }
    },
    dealTreeData: function () {
      let nameArr = []
      if (this.chks?.length > 0) {
        this.traverseTree(this.categoryTree, nameArr)
      }
      this.categoryNames = nameArr.join('，')
    },
    initCategoryTree: function () {
      let that = this
      this.categoryTree = []
      this.$axios.post(that.$apis.knowledgeApi.category.categoryTree).then(res => {
        if (res.success) {
          that.categoryTree = res.result || []
          that.dealTreeData()
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("获取知识类目失败！")
      })
    },
    renderContent (h, { root, node, data }) {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, [
        h('span', {
          style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        }, [
          h('span', data.name)
        ]),
        h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
            marginRight: '1.2rem'
          }
        }, [
        ])
      ])
    },
  },
  beforeMount () {
    this.chks = this.value
    this.close()
    document.getElementById("app").addEventListener('click', this.outClick)
    this.initCategoryTree()
  },
  beforeDestroy () {
    this.close()
    document.getElementById("app").removeEventListener('click', this.outClick)
  }
}
</script>

<style scoped>
.treePanel {
  padding: 0 1rem;
  max-width: 600px;
}
</style>
